import Form from 'react-bootstrap/Form';



interface CheckboxAddToFilterProps {
	addToFilter: boolean,
	onClick: () => void,
}


const CheckboxAddToFilter = (props: CheckboxAddToFilterProps) => {
	const { addToFilter, onClick } = props;

	return (
		<div className='popover-filter-result-item add-filter-item' onClick={onClick}>
			
			<Form.Check
				type="checkbox"
				className="app-form-checkbox"
				checked={addToFilter}
				onChange={() => {}} />

			<p>Přidat výběr do filtru</p>

		</div>
	);
};

export default CheckboxAddToFilter;